import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { useListCountriesQuery } from '../api/brokerGroupsApi';
import { getTimezoneMismatch } from '../getTimezoneMismatch';

/**
 * A broker group's timezone (from its config), shown in error with the reason on hover when
 * it isn't a timezone in the broker group's country. The country checked is the stored
 * `country` when there is one, since that's what disagrees with the config (e.g. AU groups
 * on the NZ config), or else the config's.
 */
export const BrokerGroupTimezoneCell = ({ row }) => {
	const { data: countries } = useListCountriesQuery();
	const mismatch = getTimezoneMismatch(countries, row.country ?? row.countryCode, row.timezone);

	if (!mismatch) {
		return row.timezone;
	}
	return (
		<Tooltip title={mismatch}>
			<Typography variant='body2' color='error'>
				{row.timezone}
			</Typography>
		</Tooltip>
	);
};
